import { Header } from "../components/header";
import "jquery";
import "jquery-validation";
import "footable-npm";
import * as svg4everybody from 'svg4everybody';
//import "@fancyapps/fancybox"; //we load by the old way as fancybox cant handle cases where jQuery is loaded multiple times, this way we set it to the given instance.
import "bootstrap"; //Include bootstrap here to ensure that it is included.

export class Global {
    private initFooTable() {
        ($('.footable') as any).footable({
            "empty": "Der er ingen data"
        });
    } 

    private initFooterToggle() {
        $('.js-footer-toggle').on('click', function (e) {
            var target = $(this).attr("data-target");
            $(target).toggleClass('active');
            $(this).toggleClass('open');
        })
    }

    private initDropdownMenu() { // Prevents bootstrap dropdown from closing, when choosing a filter settings!!
        $('.table-filter-menu').on('click', function (e) {
            e.stopPropagation();
        })
    }

    private initFilterToggle() { // Open/Close benchmark filter on mobile!!
        $('.js-benchmark-filter').on('click',
            function(e) {
                var target = $(this).attr("data-target");
                $(target).toggleClass('active');
            });
    }

    init(): void {
        $('[data-toggle="tooltip"]').tooltip();

        this.initFooTable();
        this.initDropdownMenu();
        this.initFilterToggle();
        this.initFooterToggle();
        const header = new Header();
        header.init();
        svg4everybody({
            nosvg: true, // shiv <svg> and <use> elements and use image fallbacks
            polyfill: true
        });
    }
}